import { useColorMode } from '@chakra-ui/react';

interface ToastContentBoxProps {
  startElement: React.ReactNode;
  position: 'top' | 'bottom';
  message: string;
}

const ToastContentBox = ({ startElement, position = 'bottom', message }: ToastContentBoxProps) => {
  const { colorMode } = useColorMode();
  const shadowStyle =
    colorMode === 'light'
      ? '0px 0px 5px 0px rgba(0, 0, 0, 0.08), 0px 0px 12px 0px rgba(0, 0, 0, 0.05)'
      : '0px 0px 5px 0px rgba(0, 0, 0, 0.15), 0px 0px 12px 0px rgba(0, 0, 0, 0.20)';

  return (
    <div
      className={`w-full flex justify-center ${position === 'top' ? 'mt-[150px]' : 'mb-[70px]'}`}
    >
      <div
        className="flex items-center justify-center bg-black-opacity-500 dark:bg-white-opacity-600 h-[40px] rounded-[30px] pl-[16px] pr-[18px] py-[12px] gap-[4px]"
        style={{
          boxShadow: shadowStyle
        }}
      >
        {startElement}
        <p className="text-pure-white dark:text-pure-black text-[14px] font-medium leading-none">
          {message}
        </p>
      </div>
    </div>
  );
};

export default ToastContentBox;
